import style from '../../components/Form.module.scss';
import Form from 'react-bootstrap/Form';
import PasswordInput from '../../components/PasswordInput';
import OnKeyUp from '../../components/OnKeyUp';
import Col from 'react-bootstrap/Col';
import { useEffect, useContext } from 'react';
import { useState } from "react";

import { AccountContext } from '../../components/Accounts';
import Warnings from '../../components/Warning';
import { navigateToDefaultRedirect, navigateToPage } from '../../services/navigateService';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import { PageEnum } from '../../enums/pageEnum';
import { Row } from 'react-bootstrap';

function Login(this: any) {
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setisLoading] = useState(false);
    const [isLoadingParams, setisLoadingParams] = useState(true);


    const navigate = useNavigate();
    const urlparams = useParams();
    const queryString = window.location.search;
    const urlQuery = new URLSearchParams(queryString);
    const params = Object.fromEntries(urlQuery.entries());
    const [email, setEmail] = useState(params.login_hint || "");

    function forgotPassword() {
        return navigateToPage(navigate, urlparams, PageEnum.RESET_PASSWORD, null, true)
    }

    function qrcodeLogin() {
        return navigateToPage(navigate, urlparams, PageEnum.QRCODE_LOGIN, null, true)
    }

    const [onKey, setOnKey] = useState(<></>);

    const { authenticate } = useContext(AccountContext);

    useEffect(() => {
        if ((!params.client_id || !params.redirect_uri)) {
            navigateToDefaultRedirect(urlparams)
            return
        }

        if (isLoadingParams) {
            setisLoadingParams(false)
            return
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const key = document.getElementById('formPassword');
        if (key) {
            key.addEventListener("keyup", function (event) {
                if (event.getModifierState("CapsLock")) {
                    setOnKey(<div className={style.warnKey} >
                        <OnKeyUp />
                    </div>
                    )
                } else {
                    setOnKey(<div></div>)
                }
            });
        }
    }, [password])

    function handleChange(e: any) {
        setPassword(e.target.value);
    }

    function handleSubmit(event: any) {
        event.preventDefault();

        setError(false);
        setisLoading(true);

        //TODO Validate if user is already logged in

        authenticate(email, password, urlparams.pool_id, params.client_id, urlparams)
            .then(() => { })
            .catch((error: any) => {
                setError(true);

                const code = error && error.messageCode
                const details = error && error.details

                if (code === "LOGIN_PERMANENTLY_BLOCKED") {
                    return setErrorMessage("Conta bloqueada. Entre em contato com o suporte.");
                }

                if (code === "LOGIN_TEMPORARILY_BLOCKED") {
                    const seconds = details && details.retryAfterSeconds
                    const minutes = seconds ? Math.ceil(seconds / 60) : null
                    return setErrorMessage(
                        minutes
                            ? `Muitas tentativas. Tente novamente em ${minutes} minuto${minutes > 1 ? "s" : ""}.`
                            : "Muitas tentativas. Tente novamente mais tarde."
                    );
                }

                if (code === "LOGIN_INVALID_CREDENTIALS") {
                    const remaining = details && details.remainingBeforeBlock
                    return setErrorMessage(
                        remaining && remaining > 0
                            ? `Email ou senha incorretos. ${remaining} tentativa${remaining > 1 ? "s" : ""} restante${remaining > 1 ? "s" : ""}.`
                            : "Email ou senha incorretos!"
                    );
                }

                setErrorMessage("Email ou senha incorretos!");
            })
            .finally(() => {
                setisLoading(false);
            })
    }

    if (isLoadingParams) {
        return <></>
    }

    return (
        <>
            <Col>
                <Form onSubmit={handleSubmit}>
                    {params.prompt === 'login' &&
                        <div className="mx-3 mx-sm-4 mx-md-5 mt-3">
                            <Warnings warning="Para sua segurança, confirme sua identidade antes de alterar dados sensíveis da sua conta." type="warning" />
                        </div>
                    }
                    <Form.Group className="my-3 mx-3 my-sm-4 mx-sm-4 my-md-4 mx-md-5" controlId="formGroupEmail">
                        <Form.Label>E-mail</Form.Label>
                        <input value={email} onChange={event => setEmail(event.target.value)}
                            className={`${style.password} ${error ? style.fieldError : style.fieldSuccess}`}
                            style={{ width: '100%' }} type="email" required />
                    </Form.Group>
                    <Form.Group className="my-3 mx-3 my-sm-4 mx-sm-4 my-md-4 mx-md-5" controlId="formGroupPassword" id="formPassword">
                        <Form.Label>Senha</Form.Label>
                        <Row>
                            <Col sm={12}>
                                <PasswordInput errors={error} id={"password"} value={password} handleChange={handleChange} />
                            </Col>
                        </Row>
                        {onKey}

                        <button type="button" onClick={forgotPassword} className='d-flex justify-content-end mt-3 btn btn-link p-0 ms-auto'>
                            Esqueci minha senha
                        </button>
                        <button type="button" onClick={qrcodeLogin} className='d-flex justify-content-end mt-2 btn btn-link p-0 ms-auto'>
                            Login com código QR
                        </button>
                        <div style={{ marginBottom: '-1em' }}>
                            {error ? <Warnings warning={errorMessage} type="error" /> : <></>}
                        </div>
                    </Form.Group>
                    <div className='d-flex justify-content-center'>
                        <button disabled={isLoading} className={style.submitButton} type="submit" id="submitButton">
                            Entrar
                        </button>
                    </div>

                </Form>
            </Col>
        </>
    )
}

export default Login;